import { Controller } from "@hotwired/stimulus"

// Renders a live elapsed-time counter based on an ISO-8601 start timestamp.
// Updates once per second; clears the interval on disconnect.
//
// Usage:
//   <span data-controller="elapsed"
//         data-elapsed-started-at-value="2026-04-21T18:30:00Z">0s</span>
export default class extends Controller {
  static values = { startedAt: String }

  connect() {
    if (!this.hasStartedAtValue || !this.startedAtValue) return
    this.startedMs = Date.parse(this.startedAtValue)
    if (isNaN(this.startedMs)) return
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    const secs = Math.max(0, Math.floor((Date.now() - this.startedMs) / 1000))
    if (secs < 60) {
      this.element.textContent = `${secs}s`
    } else {
      const mm = Math.floor(secs / 60)
      const ss = String(secs % 60).padStart(2, "0")
      this.element.textContent = `${mm}:${ss}`
    }
  }
}
